import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { AppDataService } from './app-data.service';

export const ngxAppDataServiceModule = angular.module('ngxAppDataServiceModule', [])
	.factory('ngxAppDataService', downgradeInjectable(AppDataService))
	.name;
